import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Client } from '../pages/dashboard/Clients/types';
import { showErrorToast } from '../components/ToastMessage/ToastErrorMessage';
import { clientService } from '../helpers/api/api.service';

type UseClientsArgs = {
  setClients: (clients: Client[]) => void;
  setClient: (client: Client) => void;
};

type UseClientsReturn = {
  loading: boolean;
  fetchClients: () => Promise<void>;
};

const useClients = ({ setClients, setClient }: UseClientsArgs): UseClientsReturn => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  const handleApiError = useCallback(() => {
    showErrorToast(t('Loading clients failed'));
  }, [t]);

  const fetchClientData = useCallback(async (): Promise<void> => {
    setLoading(true);
    try {
      const response = await clientService.getAllClients();
      if (response.status === 200 && response.data?.length > 0) {
        setClients(response.data as Client[]);
      } else {
        handleApiError();
      }
    } catch (error) {
      console.error('Error fetching clients:', error);
      handleApiError();
    } finally {
      setLoading(false);
    }
  }, [handleApiError, setClients, setClient]);

  return {
    loading,
    fetchClients: fetchClientData,
  };
};
export default useClients;
